import { render, staticRenderFns } from "./RowsPerPageFilter.vue?vue&type=template&id=6ba24028&scoped=true&"
import script from "./RowsPerPageFilter.vue?vue&type=script&lang=js&"
export * from "./RowsPerPageFilter.vue?vue&type=script&lang=js&"
import style0 from "./RowsPerPageFilter.vue?vue&type=style&index=0&id=6ba24028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba24028",
  null
  
)

export default component.exports